module.exports = __webpack_public_path__ + "static/links-77602e3290221b4c30feb353dbeece2f.png";